import { render, staticRenderFns } from "./DictionaryAcceptancesIndex.vue?vue&type=template&id=eb82b216&scoped=true&"
import script from "./DictionaryAcceptancesIndex.vue?vue&type=script&lang=js&"
export * from "./DictionaryAcceptancesIndex.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryAcceptancesIndex.vue?vue&type=style&index=0&id=eb82b216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb82b216",
  null
  
)

export default component.exports